import React from "react";
import "../Styles/StartEndScreen.css";
import { withRouter } from "react-router-dom";
import * as questionData from "../Scripts/QuestionnaireData";
import * as api from "../Scripts/Api";
import { CognitoHelper } from '../Utilities/CognitoHelper';

//The page after a user completes the assessment
function Finish(props) {
  let elapsedTime = api.getElapsedTime();
  console.log("total time elapsed: ", elapsedTime);
  api.record_prompt_response("TOTAL_TIME", elapsedTime/1000.0);
  sessionStorage.setItem("questionnaireIdx", 0);
  sessionStorage.setItem("testIdx", 0);
  console.log("SEEING IF BIRTHDAY IS STORED: ");
  console.log(sessionStorage.getItem("birthtext"));
  console.log(sessionStorage.getItem("firstN"));
  console.log(sessionStorage.getItem("lastN"));
  sessionStorage.setItem(
    "indicateScreening",
    questionData.riskScoreIndicatesScreening(
      JSON.parse(sessionStorage.getItem("answers"))
    )
  );

  function transitionToQMCI(event) {
    console.log("time: \n");
    console.log(api.getElapsedTime());
    let answers = JSON.parse(sessionStorage.getItem("answers"));
    let first = answers.firstName;
    let last = answers.lastName;
    let age = answers.age;
    let id = sessionStorage.getItem("screening_id");
    console.log("clicked");
    var link = `https://qmci-test.firebaseapp.com/` + '?first=' + first + '&last=' + last + '&age=' + age + '&id=' + id
    sessionStorage.clear();
    window.location.assign(link);
  }

  function validate(event){
    // const enteredCode = prompt('Please enter the passcode')
    // if (enteredCode === "1290"){
    //   transitionToQMCI(event)
    // }else{
      alert("Please return the iPad to your provider.")
    // }
  }

  function logout(event) {
    const cognitoHelper = new CognitoHelper()

    cognitoHelper.getSession(function(session) {
      cognitoHelper.signOut()

      sessionStorage.clear();

      window.location.href = '/'
    }, function(error) {
      sessionStorage.clear();

      window.location.href = '/'
    })
  }

  let prefLang = sessionStorage.getItem("preferredLanguage")
  let thanksText = prefLang !== "ES" ? "Thank you!" : "¡Gracias!"
  let completedText = prefLang !== "ES" ? "You have completed the assessment and your answers have been recorded." : "Ha completado la evaluación y sus respuestas han sido registradas."
  let returnIpadText = prefLang !== "ES" ? "Please return the iPad to your provider." : "Devuelva el iPad a su proveedor."
  return (
    <>
      <div className="card">
        <h1 className="card-title">👍 {thanksText}</h1>
        <p className="card-text">
          {completedText}
        </p>
        <h1>{returnIpadText}</h1>

        <div style={{paddingTop:50}}>
          <button style={{backgroundColor:"red"}} onClick={(event) => logout(event)}>
            Log Out
          </button>
        </div>
      </div>
    </>
  );
}
       /*  <button style={{backgroundColor:"red"}} onClick={(event) => validate(event)}>
        Continue to QMCI
        </button> */

export default withRouter(Finish);
